<div class="modal-container {{style}}" [style.display]=display id="{{ id }}" [ngStyle]="{'z-index': zIndex}">
  <div class="centered">
    <div class="modal-content py-4" [style.height]=height [style.width]=width>
      <div *ngIf="titleModal" class="row align-items-center modal-header mb-2">
        <div class="col text-center pr-0">
          <h2 id="{{idTitle}}" class="fw-bold"> {{ titleModal }}</h2>
        </div>
        <div *ngIf="iconClosed" class="col-1 text-rigth close">
          <img [src]="srcIconClosed" (click)="closeModal()" id="btn_close" alt="icon">
        </div>
      </div>
      <ng-content></ng-content>
    </div>
  </div>
</div>
